"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * ConfirmDialog - Public exports
 */
var ConfirmDialog_1 = require("./ConfirmDialog");
Object.defineProperty(exports, "ConfirmDialog", { enumerable: true, get: function () { return ConfirmDialog_1.ConfirmDialog; } });
var useConfirmDialog_1 = require("./useConfirmDialog");
Object.defineProperty(exports, "useConfirmDialog", { enumerable: true, get: function () { return useConfirmDialog_1.useConfirmDialog; } });
